import {Component, Inject, Input, OnInit, Optional} from "@angular/core";
import {ProcessService} from "../../services/process.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ProcessDefinitionService} from "../../services/definitions.service";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../../alg-auth';

@Component({
  standalone: false,
  selector: 'alg-view-process',
  templateUrl: './view-process.component.html',
  styleUrls: ['../../ui/workflow-dialog.scss'],
})
export class ViewProcessComponent implements OnInit {
  private apiUrl =  window.location.origin + '/alfresco/api/-default-/public/alfresco/versions/1';

  @Input() processId: string;

  process: any;
  variables: any;
  diagram: any;
  items: any;
  processInstance: any;
  tasksHistory: any;
  currentTask: any;
  customVariables: any;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { obj: any },
    private processService: ProcessService,
    private processDefinitionService: ProcessDefinitionService,
    private http: HttpClient,
    private authService: AuthenticationService
  ) {
    this.processId = data?.obj?.id;
  }

  ngOnInit() {
    this.processService.getProcess(this.processId).subscribe((data: any) => {
      this.process = data.entry;
      if (!this.process?.completed) {
        this.processDefinitionService.getProcessDefinitionDiagramBis(this.processId).subscribe((data: any) => {
          this.createImageFromBlob(data);
        });
      }
    });
    this.processService.getProcessVariables(this.processId).subscribe((data: any) => {
      let variables = [];
      data.list.entries.forEach(entry => {
        variables[entry.entry.name] = entry.entry.value;
      });
      this.variables = variables;
      this.customVariables = data.list.entries.filter(variable => {
        return variable.entry.name.startsWith('rc');
      })
    });
    this.processService.getProcessItems(this.processId).subscribe((data: any) => {
      this.items = data.list?.entries?.map(entry => entry.entry);
      this.items.forEach(item => {
        this.getNode(item.id).subscribe((node: any) => {
          item.parentId = node.entry.parentId;
        });
      });
    });


    this.processService.getProcessInstance(this.processId).subscribe((data: any) => {
      this.processInstance = data.data;
      this.tasksHistory = this.processInstance.tasks.filter(task => task.state === 'COMPLETED');
      this.currentTask = this.processInstance.tasks.filter(task => task.state !== 'COMPLETED')[0];
    });

  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.diagram = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }


  nameVariable(name) {
    name = name.split('_')[1];
    name = name.split(/(?=[A-Z])/).join(" ");
    name = name.charAt(0).toUpperCase() + name.slice(1);
    return name;
  }

  getNode(nodeId: string): Observable<any> {
    const endpoint = `${this.apiUrl}/nodes/${nodeId}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpoint, params);
  }
}
